module.exports = __webpack_public_path__ + "static/media/login_1.59304b68.jpg";